import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import CancelApp from "../../order/info/CancelApp";
import { canCancelSelectedOrders } from "../../../utils/orderCancellation";
import styles from "./BulkSelectionBar.module.scss";

const BulkSelectionBar = ({
  selectedCount = 0,
  totalCount = 0,
  isSelectAllLoading = false,
  onSelectAll,
  onClear,
  selectedOrders = [],
  isAirOrder = false,
  isSelectAllMode = false,
  onCancelSuccess,
}) => {
  const { t } = useTranslation();
  const [isCancelOpen, setIsCancelOpen] = useState(false);

  if (!selectedCount) return null;

  const isAllSelected = totalCount > 0 && selectedCount >= totalCount;
  const selectAllText = isAllSelected
    ? t("bulkSelectionBar.allSelected", { totalCount })
    : t("bulkSelectionBar.selectAll", { totalCount });
  const canCancelOrders =
    !isSelectAllMode &&
    selectedOrders.length === selectedCount &&
    canCancelSelectedOrders(selectedOrders, isAirOrder);

  return (
    <>
      <div className={styles.bulkSelectionBar}>
        <div className={styles.bulkSelectionInfo}>
          {t("bulkSelectionBar.selectedInfo", { selectedCount, totalCount })}
        </div>

        <div className={styles.bulkSelectionActions}>
          {canCancelOrders ? (
            <button
              type="button"
              className={`${styles.bulkSelectionButton} ${styles.bulkSelectionCancelButton}`}
              onClick={() => setIsCancelOpen(true)}
            >
              {t("bulkSelectionBar.cancelOrders")}
            </button>
          ) : null}
          <button
            type="button"
            className={styles.bulkSelectionButton}
            onClick={onSelectAll}
            disabled={isAllSelected || isSelectAllLoading}
          >
            {isSelectAllLoading ? t("bulkSelectionBar.selecting") : selectAllText}
          </button>
          <button type="button" className={styles.bulkSelectionButton} onClick={onClear}>
            {t("bulkSelectionBar.clearSelection")}
          </button>
        </div>
      </div>

      {isCancelOpen ? (
        <CancelApp
          orderIds={selectedOrders.map((order) => order.id)}
          isAirOrder={isAirOrder}
          onClose={() => setIsCancelOpen(false)}
          onUpdateData={onCancelSuccess}
        />
      ) : null}
    </>
  );
};

export default BulkSelectionBar;
